import {useMemo} from "react";
import {
	useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {
	findCloseStopsSingleVoyage,
	ICloseStopsConflictSingleVoyage
} from "@containers/singleVoyage/containers/closeStops/findCloseStops";

/** Close stop pairs of the voyage or template being edited, shared by the list notice and the map. */
export const useCloseStopsSingleVoyage = (): {
	conflicts: ICloseStopsConflictSingleVoyage[]
	conflictPointIds: Set<string>
} => {
	const {points} = useRootContextMutateSingleVoyage()

	return useMemo(() => {
		const conflicts = findCloseStopsSingleVoyage(points)
		const conflictPointIds = new Set<string>()
		conflicts.forEach(({first, second}) => {
			conflictPointIds.add(String(first.id))
			conflictPointIds.add(String(second.id))
		})
		return {conflicts, conflictPointIds}
	}, [points])
}
